module.exports = __webpack_public_path__ + "img/pr-1.10b9111f.png";